export default "__VITE_ASSET__p_x$Kg_9__"